const Lottie = dynamic(() => import('lottie-react'), { ssr: false });
import dynamic from 'next/dynamic';

import Caution from '/public/lottie/icon/icon_caution_fill_gray.json';

export default function NoData({ title, sub }: { title: string; sub: string }) {
  return (
    <div className="no_data">
      <Lottie className="no_data_caution" animationData={Caution} loop={false} />
      {title !== '' && <b>{title}</b>}
      {sub !== '' && (
        <div>
          {sub
            .split('.')
            .filter(Boolean)
            .map((sentence, index, array) => (
              <p key={index}>
                {sentence.trim()}
                {index !== array.length && '.'}
              </p>
            ))}
        </div>
      )}
    </div>
  );
}
